import { render, staticRenderFns } from "./MovementRouteLessonReview.vue?vue&type=template&id=c14c3646"
import script from "./MovementRouteLessonReview.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonReview.vue?vue&type=script&lang=js"
import style0 from "./MovementRouteLessonReview.vue?vue&type=style&index=0&id=c14c3646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports